import React, { useState } from 'react'
import { ButtonV2, SidePanelInfo } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import { QAndAContentData } from '../../../FlyOutUsageMetering/RightSectionComponents/QAndASidePannel'
import { useStyles } from './CloudSettingsHelpSections.styles'
import { Typography } from '@mui/material'
import { helpDrawerUrl } from '../../../../common/utils/constants'

interface Props {
  content?: QAndAContentData[]
  heading?: string
  showDivider?: boolean
}

export const CloudSettingsHelpSections: React.FC<Props> = ({
  content = [],
  heading,
  showDivider = true,
}) => {
  const { classes } = useStyles()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const openDrawer = () => {
    setIsOpen(true)
  }
  const toggleDrawer = async () => {
    setIsOpen(false)
  }
  const openHelpUrl = () => {
    const newWindow = window.open(
      helpDrawerUrl,
      '_blank',
      'noopener, noreferrer'
    )
    if (newWindow) newWindow.opener = null
  }

  return (
    <>
      <div>
        <ButtonV2
          key={'microsoft-cloud-settings-help-drawer'}
          styleType="link"
          data-testid="microsoft-cloud-settings-help-button-drawer"
          icon={
            <FontAwesomeIcon icon={faCircleInfo} className={classes.infoIcon} />
          }
          onClick={openDrawer}
        >
          Help & FAQs
        </ButtonV2>
      </div>
      <SidePanelInfo
        icon={
          <FontAwesomeIcon
            icon={faCircleInfo}
            className={classes.sidePanelInfoIcon}
          />
        }
        headerTitle={
          <div
            data-testid="help-and-faq-header-title"
            className={classes.sidePanelTitleText}
          >
            Help and FAQs
          </div>
        }
        title={
          showDivider ? (
            <div className={classes.horizontalDivider}></div>
          ) : undefined
        }
        open={isOpen}
        onClose={toggleDrawer}
        getHelp={openHelpUrl}
        content={
          <div className={classes.qAndAParentWrapper}>
            {heading && <span className={classes.header}>{heading}</span>}
            <div className={classes.question} data-testid="q-and-a-side-panel">
              {content.map((item, index) => (
                <div key={index} className={classes.contentWrapper}>
                  <div className={classes.qAndAWrapper}>
                    <div className={classes.qAndAContainer}>
                      <Typography className={classes.questionText}>
                        {item.question}
                      </Typography>
                      <Typography
                        className={classes.answerText}
                        component="div"
                      >
                        {item.answer}
                      </Typography>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
    </>
  )
}
